export default [{
    path: '/settingprofile',
    name: 'settingprofile',
    meta: {
      layout: 'main'
    },
    component: () => import('../../views/settingProfile/index.vue')
  }]
  